import { type Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { type Provider } from '@angular/core';

import { AuthFacade } from './auth-facade';

import { ToastService } from '@shared/ui/toast';

import { AUTH_SESSION, type AuthSession } from '@core/http';

export function provideAuthSession(): Provider {
  return {
    provide: AUTH_SESSION,
    useFactory: (facade: AuthFacade, toast: ToastService, translate: TranslateService): AuthSession => {
      return {
        refreshToken(): Observable<string | null> {
          return facade.refreshToken();
        },
        handleSessionExpired(): void {
          facade.expireSession();
          toast.error({
            summary: translate.instant('common.errors.sessionExpired'),
          });
        },
      };
    },
    deps: [AuthFacade, ToastService, TranslateService],
  };
}
